<template>
  <label class="ui-switch" :class="{ checked: value }">
    <input
      type="checkbox"
      class="ui-switch-input"
      :disabled="disabled"
      v-model="value"
      @change="$emit('update:checked', ($event.target as HTMLInputElement).checked)"
    />

    <div class="ui-switch-track"></div>
    <div class="ui-switch-thumb"></div>

    <div class="ui-switch-focus-ring"></div>
  </label>
</template>

<script lang="ts">
import { ref } from 'vue';
export default {
  name: 'ToggleComponent',
  props: {
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['update:checked'],
  setup(props: any) {
    const value = ref(props.checked || false);

    return {
      value,
    };
  },
};
</script>

<style scoped lang="scss">
$primary: #2196f3;

$thumb-size: 20px;
$thumb-bg-color: #fafafa;

$track-width: 34px;
$track-height: 14px;

$focus-ring-size: 30px;
$focus-ring-left: -(($focus-ring-size - $thumb-size) / 2);
$focus-ring-top: -(($focus-ring-size - $thumb-size) / 2);

.ui-switch {
  position: relative;
  width: $track-width;

  &.checked {
    .ui-switch-track {
      background-color: transparentize($primary, 0.5);
    }

    .ui-switch-thumb {
      left: 14px;
      background-color: $primary;
    }

    .ui-switch-focus-ring {
      left: $focus-ring-left + 14px;
      background-color: transparentize($primary, 0.12);
    }
  }
}

.ui-switch-track {
  position: absolute;
  top: (($thumb-size - $track-height) / 2);

  height: $track-height;
  width: $track-width;

  background-color: transparentize(black, 0.26);
  border-radius: 8px;

  transition: background-color 0.1s linear;
}

.ui-switch-thumb {
  position: absolute;
  top: 0;
  left: 0;

  width: $thumb-size;
  height: $thumb-size;

  border-radius: 50%;
  background-color: $thumb-bg-color;

  box-shadow: 0 1px 3px transparentize(black, 0.4);

  transition: all 0.2s ease;
}

.ui-switch-focus-ring {
  position: absolute;
  top: $focus-ring-top;
  left: $focus-ring-left;
  z-index: -1;

  border-radius: 50%;
  width: $focus-ring-size;
  height: $focus-ring-size;

  background-color: transparentize(black, 0.1);
  transform: scale(0);
  opacity: 0;

  transition: all 0.2s ease;
}

.ui-switch-input {
  position: absolute;
  opacity: 0;
}
</style>
